import { type FC } from "react";

import { clsx } from "clsx";
import { useIntl } from "react-intl";

import snapchatGhostSvg from "@app-assets/svg/snapchat.svg";

import { type AssistantChatMessageModel, AssistantChatRole } from "../model";

import styles from "./AssistantChatMessageItem.module.css";
import { AssistantMessageItem } from "./AssistantMessageItem";
import { UserMessageItem } from "./UserMessageItem";
import { messages } from "./messages.generated";

interface Props {
    message: AssistantChatMessageModel;
}

export const AssistantChatMessageItem: FC<Props> = ({ message }) =>
    message.role === AssistantChatRole.User ? (
        <UserMessageItem message={message} />
    ) : (
        <AssistantMessageItem message={message} />
    );

export const AssistantChatThinkingItem: FC = () => {
    const intl = useIntl();

    return (
        <div className={clsx(styles.row, styles.assistant)} role="status">
            <img className={styles.avatar} src={snapchatGhostSvg} alt="" />
            <span className={styles.srOnly}>{intl.formatMessage(messages.thinkingAriaLabel)}</span>
            <span className={styles.dots} aria-hidden="true">
                <span className={styles.dot} />
                <span className={styles.dot} />
                <span className={styles.dot} />
            </span>
        </div>
    );
};
